import {findLocationById} from '@frontend/helpers/findLocationById'
import {findLocationByName} from '@frontend/helpers/findLocationByName'
import type {
    AdLocation,
    AdLocations,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import type {AdsStoreState} from '@frontend/stores'

// Определить локацию для панели поиска при загрузке списка локаций.
export function detectSearchPanelLocationOnLoad(
    locations: AdLocations,
    searchPanelLocation: AdsStoreState['searchPanelLocation'],
    persistedLocationId: number | null,
    defaultLocationName: string | null
): AdsStoreState['searchPanelLocation'] {
    if (searchPanelLocation !== undefined) {
        // Уже задано, не меняем.
        return searchPanelLocation
    }
    if (
        locations.tree.length === 0
        || (!persistedLocationId && !defaultLocationName)
    ) {
        return null
    }
    if (persistedLocationId) {
        const newLocation: AdLocation | null = findLocationById(
            locations.tree,
            persistedLocationId
        )
        if (newLocation) {
            return newLocation
        }
    }
    if (persistedLocationId === 0) {
        // Опция "Все локации".
        return null
    }
    // Локации нет в локальном хранилище, поэтому используем локацию
    // "по умолчанию" для локали.
    return findLocationByName(locations.tree, defaultLocationName)
}
